import { createRoot, createSignal } from 'solid-js'
import type { ArmyPaint } from '../../../lib/core/ArmyPainter/ArmyPaint.type'
import { getJsonOrNullFromLocalStorage } from '../../../lib/localStorage'
import { ArmyPaintSchema } from '../../../lib/core/ArmyPainter/ArmyPaint.type'
import { safeParse } from 'valibot'
import type { Nullable } from '../../../typescript'

export const AP_SELECTED_LS_KEY = 'ap_selected'

function getInitialSelectedArmyPaint(): Nullable<ArmyPaint> {
  const raw = getJsonOrNullFromLocalStorage(AP_SELECTED_LS_KEY)
  const result = safeParse(ArmyPaintSchema, raw)
  return result.success ? (result.output as ArmyPaint) : null
}

const signal = createRoot(() => {
  const [getArmyPaint, setArmyPaint] = createSignal<Nullable<ArmyPaint>>(getInitialSelectedArmyPaint())

  const update = (ap: Nullable<ArmyPaint>) => {
    setArmyPaint(ap)
    if (ap) {
      localStorage.setItem(AP_SELECTED_LS_KEY, JSON.stringify(ap))
    } else {
      localStorage.removeItem(AP_SELECTED_LS_KEY)
    }
  }

  return [getArmyPaint, update] as const
})

export const [getAuthArmyPaint, setAuthArmyPaint] = signal
